import type { MailboxInfo } from "owa-client-types";
import { isAccountFeatureEnabled } from "owa-feature-flags";

/**
 * Entity recognition A/B/C experiment arm:
 *  - control (A): default experience, service-side people experiments stay on.
 *  - virtualControl (B): service-side people experiments are disabled, no client entity recognition.
 *  - treatment (C): service-side people experiments are disabled and the client entity-recognition
 *    library rewrites the query.
 */
export type EntityRecognitionExperimentArm = "control" | "virtualControl" | "treatment";

export default function getEntityRecognitionExperimentArm(mailboxInfo: MailboxInfo): EntityRecognitionExperimentArm {
    const isClientOn = isAccountFeatureEnabled("sea-entityRecognitionClientOn", mailboxInfo);
    const isBothOff = isAccountFeatureEnabled("sea-entityRecognitionBothOff", mailboxInfo);
    
    // Conflicting arms must not change the default experience.
    if (isClientOn && isBothOff) {
        return "control";
    }
    if (isClientOn) {
        return "treatment";
    }
    if (isBothOff) {
        return "virtualControl";
    }
    return "control";
}

export function isClientEntityRecognitionEnabled(mailboxInfo: MailboxInfo): boolean {
    return getEntityRecognitionExperimentArm(mailboxInfo) === "treatment";
}

export function shouldDisableEntityRecognitionServerFlights(mailboxInfo: MailboxInfo): boolean {
    return getEntityRecognitionExperimentArm(mailboxInfo) !== "control";
}
